module.exports = __webpack_public_path__ + "img/edit-white.ba3330d3.svg";